// 50% Off Tacos Mulitas Taco Tuesday — Burbank, NoHo & Van Nuys.
//
// Replaces the old tuesday-only menu categories (hidden in ./index.js
// subMenuFilter while this is enabled). The promo category is built
// client-side from products tagged `vfiftydeal` at half price and prepended
// to the menu in src/Context/applyDiscount.js, so nothing has to change in
// the POS menu beyond tagging the products. Flip `tacoTuesdayFiftyEnabled`
// to false to retire it and bring the old tuesday-only categories back.

export const tacoTuesdayFiftyEnabled = true

export const tacoTuesdayFiftyShopIds = [
  'pablitostacosburbank',
  'pablitostacosnoho',
  'pablitostacosvannuys',
]

// Returns true when today (in America/Los_Angeles) is Tuesday, regardless
// of the user's device timezone.
export function isLATuesday() {
  try {
    const day = new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      timeZone: 'America/Los_Angeles',
    }).format(new Date())
    return day === 'Tue'
  } catch (e) {
    return new Date().getDay() === 2
  }
}

export function isTacoTuesdayFifty() {
  return tacoTuesdayFiftyEnabled && isLATuesday()
}

export function isTacoTuesdayFiftyLive(shopId) {
  return tacoTuesdayFiftyShopIds.indexOf(shopId) !== -1 && isTacoTuesdayFifty()
}

// Builds the promo category from the shop's live menu. Returns null when no
// products are tagged `vfiftydeal`, so we never show an empty promo.
export function buildTacoTuesdayFiftyCategory(menu) {
  const products = []
  const subMenus = (menu && menu.subMenus) || []
  subMenus.forEach((subMenu) => {
    (subMenu.products || []).forEach((product) => {
      if (product.tags && product.tags.indexOf('vfiftydeal') !== -1) {
        products.push(Object.assign({}, product, {
          id: product.id + '-vfiftydeal',
          originalPrice: product.price,
          price: Math.floor(product.price * 0.5 * 100) / 100,
        }))
      }
    })
  })
  if (products.length === 0) { return null }

  return {
    id: 'taco-tuesday-fifty',
    // real categories all carry shopId — AutoMenu drops categories without one
    // when it is handed a shopId prop
    shopId: menu && menu.shopId,
    name: {en: '🌮 TACO TUESDAY — 50% Off Tacos Mulitas'},
    description: {en: '50% off tacos mulitas — Tuesdays only!'},
    tag: 'vfiftydeal-promo',
    products,
  }
}
